module.exports = __webpack_public_path__ + "img/icon-ew-big.7994e84d.svg";